export const scrollToError = (errors: Record<string, any> | null) => {
  if (!errors) return;

  const keys = getKeys(errors);

  if (!keys.length) return;
  const input =
    document.querySelector(`input[name*="${keys[0]}"]`) ||
    document.querySelector(`textarea[name*="${keys[0]}"]`) ||
    document.querySelector(`div[data-name*="${keys[0]}"]`);

  if (!input || isInViewport(input)) return;

  input.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
};

const isInViewport = (element: Element, offset = -50) => {
  const { top } = element.getBoundingClientRect();
  return top + offset >= 0 && top - offset <= window.innerHeight;
};

const isObject = (obj: any) => obj != null && obj.constructor.name === 'Object';
const getKeys = (obj: Record<string, any>, keys: string[] = [], scope: string[] = []) => {
  if (Array.isArray(obj)) {
    obj.forEach((o) => getKeys(o, keys, scope), keys);
  } else if (isObject(obj)) {
    Object.keys(obj).forEach((k: string) => {
      if (!Array.isArray(obj[k]) && !isObject(obj[k])) {
        const path = scope.concat(k).join('.').replace(/\.\[/g, '[');
        if (!keys.includes(path)) keys.push(path);
      }
      getKeys(obj[k], keys, scope.concat(k));
    }, keys);
  }
  return keys;
};
